module.exports = __webpack_public_path__ + "img/print-check-box-ticked.18ed75ea.svg";